import 'element-plus/dist/index.css'

import { ButtonComponent } from '@metapic-apps/shared'
import * as Sentry from '@sentry/vue'
import { plugin as unleashPlugin } from '@unleash/proxy-client-vue'
import vClickOutside from 'click-outside-vue3'
import ElementPlus from 'element-plus'
import { createPinia } from 'pinia'
import { posthog } from 'posthog-js'
import 'quill/dist/quill.snow.css'
import { createApp } from 'vue'
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'
import VueFormWizard from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import { VueTelInput } from 'vue-tel-input'
import 'vue-tel-input/vue-tel-input.css'
import VueVirtualScroller from 'vue-virtual-scroller'
import Paginate from 'vuejs-paginate'

import App from './App.vue'
import { Alert, GuideMessage, MenuButton, SearchBox, VButton } from './components'
import store from './legacy/store'
import router from './router/'

import { config, errorHandler, installProviders, isDemoMode, unleashClient } from '@/lib'

import '@/assets/styles/main.css'
import '@/legacy/styles/index.scss'
import 'bootstrap'
import 'chart.js/auto'
import 'chartjs-adapter-moment'
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'

const app = createApp(App)
app.use(store)
app.use(createPinia())
app.use(router)
app.use(ElementPlus)
app.use(unleashPlugin, { unleashClient, startClient: !isDemoMode })
app.use(VueFormWizard)
// app.use(VueMask);
app.use(VueTelInput, { mode: 'international' })
app.use(errorHandler)
// @ts-expect-error todo fix me
app.use(VueVirtualScroller)

app.component('Paginate', Paginate)
app.component('VueCtkDateTimePicker', VueCtkDateTimePicker)
app.component('ButtonComponent', ButtonComponent)

app.component('VButton', VButton)

app.component('Alert', Alert)
app.component('MenuButton', MenuButton)
app.component('GuideMessage', GuideMessage)
app.component('SearchBox', SearchBox)
app.use(vClickOutside)

// @ts-expect-error todo fix me
window.apiUrl = config.metapicApiUrl

const DEMO_SENTRY_ENVIRONMENTS: Partial<Record<string, string>> = {
  development: 'development-demo',
  staging: 'staging-demo',
  production: 'production-demo',
}

if (config.environment !== 'local') {
  Sentry.init({
    app,
    dsn: config.sentryDsn,
    sendDefaultPii: false,
    integrations: [Sentry.browserTracingIntegration({ router }), Sentry.replayIntegration()],
    tracesSampleRate: 0,
    replaysSessionSampleRate: 0.01,
    replaysOnErrorSampleRate: 1.0,
    environment: isDemoMode
      ? (DEMO_SENTRY_ENVIRONMENTS[config.environment] ?? config.environment)
      : config.environment,
  })
}

if (config.isPosthogEnabled) {
  posthog.init(config.postHogApiKey, {
    api_host: 'https://eu.i.posthog.com',
    opt_out_capturing_by_default: true,
    session_recording: {
      maskAllInputs: true,
    },
  })
}

installProviders(app)

app.mount('#app')

export default app
